import { render } from "./SlidesModal.vue?vue&type=template&id=c6972166&scoped=true"
import script from "./SlidesModal.vue?vue&type=script&lang=js"
export * from "./SlidesModal.vue?vue&type=script&lang=js"

import "./SlidesModal.vue?vue&type=style&index=0&id=c6972166&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6972166"]])

export default __exports__